export const SET_STATUS_HISTORY = 'involvedParties/SET_STATUS_HISTORY';
export const SET_STATUS_CODE_TYPES = 'involvedParties/SET_STATUS_CODE_TYPES';
